import { render, staticRenderFns } from "./Games.vue?vue&type=template&id=7c34e0e6"
import script from "./Games.vue?vue&type=script&lang=js"
export * from "./Games.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports